import { Button } from "reactstrap";
import error404 from "@src/assets/images/error/error404.svg";

export const Error404 = () => {
    return (
        <div
            className={
                "d-flex flex-column align-items-center justify-content-center vh-100 gap-1"
            }
        >
            <h1 className={"fw-bolder"}>Oops, 404 Error</h1>
            <h6>Page Not Found</h6>
            <div className={"mb-2"}>
                <a href={"/home"}>
                    <Button color={"primary"}>Back to Home</Button>
                </a>
            </div>
            <img src={error404} alt={"error 404"} />
        </div>
    );
};
